import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const CDL = styled.div`
  margin: 38px 20px;
  padding: 10px;
  display: flex;
  align-items: center;

  button {
    width: 86px;
    background-color: #fff;
    border: 1px solid #c4c4c4;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Devedor = styled.div`
  margin: 20px;
  color: #fff;
`;

interface ButtonProps {
  isActive: boolean;
}

export const Button = styled.button<ButtonProps>`
  background: ${(props) =>
    props.isActive ? 'var(--color-primary)' : '#c4c4c4'};
  margin: 10px;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 6px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;

  text-decoration: none;
`;
